import { Environment, Network, RecordSource, Store } from 'relay-runtime';

import { inferredTenantRedirect } from 'src/login/sessionManager';
import { api } from 'src/services/apiService';
import { logoutUserSessionExpired } from 'src/utils/login';

async function fetchRelay(params, variables) {
    try {
        const { data, headers } = await api.post('/graphql', {
            query: params.text,
            variables,
        });
        await inferredTenantRedirect(headers, `/graphql : ${params.text}`);
        return data;
    } catch (error) {
        if (error?.response?.status === 401) {
            return logoutUserSessionExpired();
        }
        return {
            data: {},
            errors: [{}],
        };
    }
}

// used in Relay and not in redux-thunk // check environment.ts for redux-thunk
const relayEnvironment = new Environment({
    network: Network.create(fetchRelay),
    store: new Store(new RecordSource()),
});

export default relayEnvironment;
